import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import {
  retrieveCaByUnit,
  retrieveCaByGroup,
  retrieveGadsSummaryByGroup,
  retrieveGadsSummaryByUnit,
} from '../actions'
import { getUnitMap } from 'analytics/selectors'
import { getCaData, getGadsSummarizedData } from '../selectors'
import { Scatter, Graph, createMeasurement } from 'integ-graphs'
import UnitGroupSelection from './UnitGroupSelection'

const measurement = createMeasurement({
  margin: { top: 20, right: 60, bottom: 40, left: 70 },
})

const Circle = styled.circle`
  fill: rgba(70, 130, 180, 0.15);
  stroke: steelblue;
  stroke-width: 3px;
  &:hover {
    fill: rgba(70, 130, 180, 0.65);
    stroke: steelblue;
  }
`

const ScatterChart = ({ spec, retrieveByGroup, retrieveByUnit, data, unitMap }) => [
  <UnitGroupSelection key="selection" {...{ retrieveByGroup, retrieveByUnit }} />,
  <h3 key="title">{spec.label} </h3>,
  <Graph key="scatter-graph" measurement={measurement}>
    <Scatter
      data={data}
      measurement={measurement}
      {...spec}
      defaultRadius={10}
      circleRenderer={props => (
        <Circle {...props}>
          <title>{unitMap[props.data.unitId] || props.data.unitId}</title>
        </Circle>
      )}
    />
  </Graph>,
]

const mapDispatchToProps = (dispatch, { group }) =>
  group === 'CA'
    ? {
        retrieveByUnit: (...args) => dispatch(retrieveCaByUnit(...args)),
        retrieveByGroup: (...args) => dispatch(retrieveCaByGroup(...args)),
      }
    : {
        // change to appropriate b
        retrieveByUnit: (...args) => dispatch(retrieveGadsSummaryByUnit(...args)),
        retrieveByGroup: (...args) => dispatch(retrieveGadsSummaryByGroup(...args)),
      }

const mapStateToProps = (state, { group }) => ({
  unitMap: getUnitMap(state),
  data: group === 'CA' ? getCaData(state) : getGadsSummarizedData(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScatterChart)
